import {
  IApiRequest,
  IApiResponse,
  ICreateMemoRequest,
  ICreditMemoDetailsResponse,
} from "@miplatform/types";
import {
  ACCOUNT_SERVICE,
  API_VERSION,
  X_API_VERSION,
} from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_CREDIT_MEMOS = `${ACCOUNT_SERVICE}/credit-memos`;

export const creditMemos = {
  getAll: async (
    config: IApiRequest = {}
  ): Promise<IApiResponse<ICreditMemoDetailsResponse[]>> => {
    const options = await apiOptions({
      url: `${API_CREDIT_MEMOS}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      ...config,
    });
    return apiRequest(options);
  },
  get: async (
    id: string
  ): Promise<IApiResponse<ICreditMemoDetailsResponse>> => {
    const options = await apiOptions({
      url: `${API_CREDIT_MEMOS}/${id}`,
      method: "get",
    });
    return apiRequest(options);
  },
  create: async ({
    data,
    toastMessageConfig,
  }: IApiRequest<ICreateMemoRequest>): Promise<
    IApiResponse<ICreditMemoDetailsResponse>
  > => {
    const options = await apiOptions({
      url: API_CREDIT_MEMOS,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  update: async ({
    id,
    data,
    modifiedOn,
    toastMessageConfig,
  }: IApiRequest<Partial<ICreateMemoRequest>>): Promise<
    IApiResponse<ICreditMemoDetailsResponse>
  > => {
    const options = await apiOptions({
      url: `${API_CREDIT_MEMOS}/${id}`,
      method: "patch",
      headers: { [X_API_VERSION]: API_VERSION },
      data: { ...data, modifiedOn },
    });
    return apiRequest(options, toastMessageConfig);
  },
  void: async ({
    id,
    modifiedOn,
    toastMessageConfig,
  }: IApiRequest): Promise<IApiResponse<void>> => {
    const options = await apiOptions({
      url: `${API_CREDIT_MEMOS}/${id}/void`,
      method: "put",
      headers: { [X_API_VERSION]: API_VERSION },
      data: { modifiedOn },
    });
    return apiRequest(options, toastMessageConfig);
  },
};
